import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Map } from 'immutable';
import { injectIntl, defineMessages } from 'react-intl';
import ReactHtmlParser from 'react-html-parser';

import { Image, Message } from 'semantic-ui-react';
import * as commonVar from 'libs/commonVar';

import { Help } from 'components';

import * as common from 'libs/commonFunc';

import classNames from 'classnames/bind';
import styles from './StartExam.css';
const cx = classNames.bind(styles);

class StartExamWizardContentStep5 extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { examFail, examResultData, moveExamResult } = this.props;

    let resultDetail = null;
    let resultGo = null;

    const confirm = examResultData.success[0];

    let licenseType = null;
    let licenseInfo = null;
    if (confirm) {
      if (confirm.licenseType !== null) {
        licenseType = confirm.licenseType;
        licenseInfo = confirm.licenseInfo;
      }
    }
    const licenseConfirm = [];

    if (licenseType === 1 || licenseType === 2) {
      licenseInfo.map((periLi, index) => {
        if ((periLi.endEpoch - common.nowEpoch()) / 86400 < 31) {
          const startDate = periLi.startEpoch;
          const endDate = periLi.endEpoch;
          const dateInform = (
            <div className={cx('inform-wrap')} key={index}>
              <div className={cx('license-name')}>
                <span className={cx('dot')}>·</span>
                {defineMessages(formatMessage({ id: 'LicenseEdit_25', defaultMessage: '기간 라이센스' }))}
              </div>
              <div className={cx('license-content')}>
                <div className={cx('license-number')}>#{periLi.licenseNo}</div>
                <div className={cx('license-text')}>
                  {common.timeFormatFromUTCEpoch(startDate, 3) +
                    ' ~ ' +
                    common.timeFormatFromUTCEpoch(endDate, 3) +
                    ' '}
                  <span className={cx('rest-license')}>
                    {'(' +
                      defineMessages(formatMessage({ id: 'StartExamWizardContent_105', defaultMessage: '남은 기간' })) +
                      ' : ' +
                      common.timeDiffFromUTCEpoch(endDate) +
                      ')'}
                  </span>
                </div>
              </div>
            </div>
          );

          licenseConfirm.push(dateInform);
        }
      });
    } else if (licenseType === 4) {
      licenseInfo.map((countLi, index) => {
        // const useCount = countLi.examLimitInfo ? countLi.examLimitInfoCount : null;
        const useCount = countLi.limitInfo ? countLi.limitInfo.length : null;
        const leftCount = parseInt(countLi.examLimitCount) - useCount;
        const countInform = (
          <div className={cx('inform-wrap')} key={index}>
            <div className={cx('license-name')}>
              <span className={cx('dot')}>·</span>
              {defineMessages(formatMessage({ id: 'LicenseEdit_26', defaultMessage: '횟수 라이센스' }))}
            </div>
            <div className={cx('license-content')}>
              <div className={cx('license-number')}>#{countLi.licenseNo}</div>
              <div className={cx('license-text')}>
                <span className={cx('license-expire')}>
                  {defineMessages(formatMessage({ id: 'StartExamWizardContent_106', defaultMessage: '훈련 횟수' }))}
                </span>
                {' ' +
                  useCount +
                  ' / ' +
                  parseInt(countLi.examLimitCount) +
                  defineMessages(formatMessage({ id: 'StartExamWizardContent_107', defaultMessage: '회' })) +
                  ' '}
                <span className={cx('rest-license')}>
                  {'(' +
                    defineMessages(formatMessage({ id: 'StartExamWizardContent_108', defaultMessage: '잔여 횟수' })) +
                    ' : ' +
                    leftCount +
                    defineMessages(formatMessage({ id: 'StartExamWizardContent_107', defaultMessage: '회' })) +
                    ')'}
                </span>
              </div>
            </div>
          </div>
        );

        licenseConfirm.push(countInform);
      });
    }

    if (examFail) {
      // 훈련 실행 요청되기 전에 오류가 발견됨
      resultDetail = (
        <div className={cx('result-detail')}>
          <Message negative>{examFail}</Message>
        </div>
      );
    } else {
      if (examResultData) {
        if (examResultData.result === 1 && examResultData.success) {
          // 훈련 실행 요청이 전달되고 정상적으로 처리됨
          const d = examResultData.success[0];
          const nowEpoch = new Date().getTime() / 1000;

          let licenseWrite = null;
          const licensStatus = (
            <div className={cx('result-item-area')}>
              <Image src="/img/examStart/ico_check_y.png" />
              <div className={cx('result-item')}>
                <div className={cx('result-item-title')}>
                  {defineMessages(formatMessage({ id: 'StartExamWizardContent_101', defaultMessage: '라이센스 현황' }))}
                </div>
                <div className={cx('result-item-content')}>{licenseConfirm}</div>
              </div>
            </div>
          );

          if (licenseConfirm && licenseConfirm.length > 0) {
            licenseWrite = licensStatus;
          }

          resultDetail = (
            <div className={cx('result-detail')}>
              <div className={cx('result-list')}>
                {/* ---------- 훈련명 ---------- */}
                <div className={cx('result-item-area')}>
                  <Image src="/img/examStart/ico_check_y.png" />
                  <div className={cx('result-item')}>
                    <div className={cx('result-item-title')}>
                      {defineMessages(formatMessage({ id: 'StartExamWizardContent_51', defaultMessage: '훈련명' }))}
                    </div>
                    <div className={cx('result-item-content')}>
                      {!!d && d.examNoArray && d.examName + ' (No.' + d.examNoArray.join(', ') + ')'}
                    </div>
                  </div>
                </div>
                {/* ---------- 훈련 기간 ---------- */}
                <div className={cx('result-item-area')}>
                  <Image src="/img/examStart/ico_check_y.png" />
                  <div className={cx('result-item')}>
                    <div className={cx('result-item-title')}>
                      {defineMessages(formatMessage({ id: 'StartExamWizardContent_115', defaultMessage: '훈련 기간' }))}
                    </div>
                    <div className={cx('result-item-content')}>
                      {common.timeFormatFromUTCEpoch(d.examStartEpoch, 3) +
                        ' ~ ' +
                        common.timeFormatFromUTCEpoch(d.examEndEpoch, 3)}
                      {d.examStartEpoch > nowEpoch + 1000 &&
                        ' ' +
                          defineMessages(
                            formatMessage({ id: 'StartExamWizardContent_52', defaultMessage: '(예약됨)' })
                          )}
                    </div>
                  </div>
                </div>
                {/* ---------- 훈련 대상 ---------- */}
                <div className={cx('result-item-area')}>
                  <Image src="/img/examStart/ico_check_y.png" />
                  <div className={cx('result-item')}>
                    <div className={cx('result-item-title')}>
                      {defineMessages(formatMessage({ id: 'StartExamWizardContent_53', defaultMessage: '훈련대상' }))}
                    </div>
                    <div className={cx('result-item-content')}>
                      {d.targetCount +
                        defineMessages(formatMessage({ id: 'StartExamWizardContent_13', defaultMessage: '명' }))}
                      {d.createTargetCount > 0 && (
                        <span>
                          {' (' +
                            defineMessages(formatMessage({ id: 'StartExamWizardContent_54', defaultMessage: '신규' }))}
                          <Help
                            triggerProps={{ name: 'help circle', className: cx('exam-help-icon') }}
                            position="top left"
                            helpMessage={defineMessages(
                              formatMessage({
                                id: 'StartExamWizardContent_55',
                                defaultMessage:
                                  '훈련 대상 선택에서 개별 email 을 추가한 경우 기존에 등록된 대상자의 email 이 아니면 신규 대상자로 자동 등록됩니다.'
                              })
                            )}
                          />
                          {': ' +
                            d.createTargetCount +
                            defineMessages(formatMessage({ id: 'StartExamWizardContent_13', defaultMessage: '명' }))})
                        </span>
                      )}
                    </div>
                  </div>
                </div>
                {/* ---------- 훈련 메일 나눔 발송 ---------- */}
                {!!d.sendReservePeriod ? (
                  <div className={cx('result-item-area')}>
                    <Image src="/img/examStart/ico_check_y.png" />
                    <div className={cx('result-item')}>
                      <div className={cx('result-item-title')}>
                        {defineMessages(
                          formatMessage({ id: 'StartExamWizardContent_82', defaultMessage: '훈련 메일 나눔 발송' })
                        )}
                      </div>
                      <div className={cx('result-item-content')}>
                        {d.sendReservePeriod === 1
                          ? common.timeFormatFromUTCEpoch(d.examStartEpoch, 3)
                          : common.timeFormatFromUTCEpoch(d.examStartEpoch, 3) +
                            ' ~ ' +
                            common.timeFormatFromUTCEpoch(d.examStartEpoch + 86400 * (d.sendReservePeriod - 1), 3)}
                        {' (' +
                          d.sendReserveStartHour +
                          defineMessages(formatMessage({ id: 'StartExamWizardContent_81', defaultMessage: '시' })) +
                          '~' +
                          d.sendReserveEndHour +
                          defineMessages(formatMessage({ id: 'StartExamWizardContent_81', defaultMessage: '시' })) +
                          ')'}
                      </div>
                    </div>
                  </div>
                ) : (
                  ''
                )}
                {/* ---------- PC 잠금 화면 시간 ---------- */}
                {d.attachScreenLockEpoch && (
                  <div className={cx('result-item-area')}>
                    <Image src="/img/examStart/ico_check_y.png" />
                    <div className={cx('result-item')}>
                      <div className={cx('result-item-title')}>
                        {defineMessages(
                          formatMessage({
                            id: 'StartExamWizardContent_31',
                            defaultMessage: 'PC 잠금 화면 실행 시간'
                          })
                        )}
                      </div>
                      <div className={cx('result-item-content')}>
                        {common.timeFormatFromUTCEpoch(d.attachScreenLockEpoch, 2)}
                      </div>
                    </div>
                  </div>
                )}
                {/* ---------- 훈련 양식 ---------- */}
                <div className={cx('result-item-area')}>
                  <Image src="/img/examStart/ico_check_y.png" />
                  <div className={cx('result-item')}>
                    <div className={cx('result-item-title')}>
                      {defineMessages(formatMessage({ id: 'StartExamWizardContent_56', defaultMessage: '훈련양식' }))}
                    </div>
                    <div className={cx('result-item-content')}>
                      {!!d.serviceTemplateNameArray &&
                        ReactHtmlParser('<div>· ' + d.serviceTemplateNameArray.join('</div><div>· ') + '</div>')}
                      {!!d.examTemplateNameArray &&
                        ReactHtmlParser('<div>· ' + d.examTemplateNameArray.join('</div><div>· ') + '</div>')}
                    </div>
                  </div>
                </div>
                {/* ---------- 라이센스 현황 ---------- */}
                {licenseWrite}
              </div>
            </div>
          );
          resultGo = (
            <div
              className={cx('result-go-area')}
              onClick={(e, data) => {
                moveExamResult('/main/exam');
              }}>
              <div className={cx('result-go')}>
                {defineMessages(formatMessage({ id: 'Header_4', defaultMessage: '훈련결과' }))}
              </div>
              {defineMessages(
                formatMessage({
                  id: 'StartExamWizardContent_58',
                  defaultMessage: '에서 세부 내용을 확인할 수 있습니다.'
                })
              )}
            </div>
          );
        } else if (examResultData.result === 0 && examResultData.error && Array.isArray(examResultData.error)) {
          // 훈련 실행 요청이 전달되었으나 오류가 반환됨
          resultDetail = (
            <div className={cx('result-detail')}>
              <Message negative>{examResultData.error.map(e => <p key={e}>{e.errorInfo || ''}</p>)}</Message>
            </div>
          );
        } else {
          // ?
        }
      } else {
        // ?
      }
    }

    return (
      <div className={cx('result-area')}>
        {resultDetail}
        {resultGo}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  templateAttach: state.templateAttach.getIn(['data', 'success']),
  templateAttachIndex: state.templateAttach.get('listIndexByNo')
});

export default connect(mapStateToProps)(injectIntl(StartExamWizardContentStep5));



// WEBPACK FOOTER //
// ./src/script/components/exam-start/StartExamWizardContentStep5.js